import store from "@/state/store";

let routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      guest: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/pages/account/profile"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/pages/account/register"),
    meta: {
      guest: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/reset-password"),
    meta: {
      guest: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password/:token",
    name: "Reset-password",
    component: () => import("../views/pages/account/reset-password"),
    meta: {
      guest: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: "home" } : { ...routeFrom });
      },
    },
  },
  {
    path: "",
    name: "home",
    component: () => import("../views/pages/dashboard/index"),
    label: "داشبورد",
    icon: "ri-dashboard-line",
    meta: { sidebar: true },
  },
  {
    path: "/applications",
    name: "applications",
    meta: { permission: "read application", sidebar: true },
    label: "اپلیکیشن ها",
    icon: "ri-apps-line",
    component: () => import("../App"),
    children: [
      {
        path: "",
        name: "applications",
        meta: { permission: "read application", sidebar: true },
        label: "لیست اپلیکیشن ها",
        component: () => import("../views/pages/applications/index"),
      },
      {
        path: "create",
        name: "applications.create",
        meta: { role: "Developer", sidebar: true },
        label: "ثبت اپلیکیشن جدید",
        component: () => import("../views/pages/applications/form"),
      },
      {
        path: ":id/edit",
        name: "applications.edit",
        meta: { role: "Developer" },
        component: () => import("../views/pages/applications/form"),
      },
      {
        path: ":id",
        name: "applications.show",
        meta: { permission: "read application" },
        component: () => import("../views/pages/applications/show"),
      },
    ],
  },
  {
    path: "/applications/:applicationId/leagues",
    name: "applications.leagues",
    meta: { permission: "read league" },
    component: () => import("../views/pages/leagues/index"),
  },
  {
    path: "/applications/:id/leader-board",
    name: "applications.leader-board",
    meta: { permission: "read application_leaderboard" },
    component: () => import("../views/pages/applications/leader-board/index"),
  },
  {
    path: "/campaigns",
    name: "campaigns",
    meta: { permission: "read campaign", sidebar: true },
    label: "کمپین ها",
    icon: "ri-advertisement-line",
    component: () => import("../App"),
    children: [
      {
        path: "",
        name: "campaigns",
        meta: { permission: "read campaign" },
        label: "لیست کمپین ها",
        component: () => import("../views/pages/campaigns/index"),
      },
      {
        path: "create",
        name: "campaigns.create",
        meta: { role: "Developer", sidebar: true },
        label: "ثبت کمپین جدید",
        component: () => import("../views/pages/campaigns/form"),
      },
      {
        path: ":id/edit",
        name: "campaigns.edit",
        meta: { role: "Developer" },
        component: () => import("../views/pages/campaigns/form"),
      },
      {
        path: ":id",
        name: "campaigns.show",
        meta: { permission: "read campaign" },
        component: () => import("../views/pages/campaigns/show"),
      },
    ],
  },

  {
    path: "/leagues",
    name: "leagues",
    meta: { permission: "read league", sidebar: true },
    label: "لیگ ها",
    icon: "ri-gamepad-line",
    component: () => import("../App"),
    children: [
      {
        path: "",
        name: "leagues",
        meta: { permission: "read league", sidebar: true },
        label: "لیست لیگ ها",
        component: () => import("../views/pages/leagues/index"),
      },
      {
        path: "create",
        name: "leagues.create",
        meta: { role: "Developer", sidebar: true },
        label: "ثبت لیگ جدید",
        component: () => import("../views/pages/leagues/form"),
      },
      {
        path: ":id/edit",
        name: "leagues.edit",
        meta: { role: "Developer" },
        component: () => import("../views/pages/leagues/form"),
      },
      {
        path: ":id",
        name: "leagues.show",
        meta: { permission: "read league" },
        component: () => import("../views/pages/leagues/show"),
      },
    ],
  },
  {
    path: "/leagues/:id/leader-board",
    name: "leagues.leader-board",
    meta: { permission: "read league_leaderboard" },
    component: () => import("../views/pages/leagues/leader-board/index"),
  },
  {
    path: "/leagues/:leagueId/rewards",
    name: "leagues.rewards",
    meta: { permission: "read league_reward" },
    component: () => import("../views/pages/leagues/rewards/index"),
  },
  {
    path: "/leagues/:leagueId/rewards/create",
    name: "leagues.rewards.create",
    meta: { role: "Developer" },
    component: () => import("../views/pages/leagues/rewards/form"),
  },
  {
    path: "/leagues/:leagueId/rewards/:id/edit",
    name: "leagues.rewards.edit",
    meta: { role: "Developer" },
    component: () => import("../views/pages/leagues/rewards/form"),
  },
  {
    path: "/leagues/:leagueId/rewards/:id",
    name: "leagues.rewards.show",
    meta: { permission: "read league_reward" },
    component: () => import("../views/pages/leagues/rewards/show"),
  },
  {
    path: "/leagues/:leagueId/data-fields",
    name: "leagues.data-fields",
    meta: { role: "Developer" },
    component: () => import("../views/pages/leagues/data-fields/index"),
  },
  {
    path: "/leagues/:leagueId/data-fields/create",
    name: "leagues.data-fields.create",
    meta: { role: "Developer" },
    component: () => import("../views/pages/leagues/data-fields/form"),
  },
  {
    path: "/leagues/:leagueId/data-fields/:id/edit",
    name: "leagues.data-fields.edit",
    meta: { role: "Developer" },
    component: () => import("../views/pages/leagues/data-fields/form"),
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { permission: "read notification" },
    component: () => import("../views/pages/notifications/index"),
  },
  {
    path: "/notifications/create",
    name: "notifications.create",
    meta: { role: "Developer" },
    component: () => import("../views/pages/notifications/form"),
  },
  {
    path: "/notifications/:id/edit",
    name: "notifications.edit",
    meta: { role: "Developer" },
    component: () => import("../views/pages/notifications/form"),
  },
  {
    path: "/notifications/:id",
    name: "notifications.show",
    meta: { permission: "read notification" },
    component: () => import("../views/pages/notifications/show"),
  },
  {
    path: "/register-codes",
    name: "register-codes",
    meta: { role: "Developer", sidebar: true },
    label: "کدهای رجیستری",
    icon: "ri-registered-line",
    component: () => import("../App"),
    children: [
      {
        path: "",
        name: "register-codes",
        meta: { role: "Developer", sidebar: true },
        label: "لیست کدهای رجیستری",
        component: () => import("../views/pages/register-codes/index"),
      },
      {
        path: "create",
        name: "register-codes.create",
        meta: { role: "Developer", sidebar: true },
        label: "ثبت کد جدید",
        component: () => import("../views/pages/register-codes/form"),
      },
    ],
  },
  {
    path: "/register-codes/:applicationId/create",
    name: "register-codes.create",
    meta: { authRequired: true },
    component: () => import("../views/pages/register-codes/form"),
  },
  {
    path: "/applications/:applicationId/register-codes/:id/edit",
    name: "register-codes.edit",
    meta: { role: "Developer" },
    component: () => import("../views/pages/register-codes/form"),
  },
  {
    path: "/applications/:applicationId/data-fields",
    name: "applications.data-fields",
    meta: { role: "Developer" },
    component: () => import("../views/pages/applications/data-fields/index"),
  },
  {
    path: "/applications/:applicationId/data-fields/create",
    name: "applications.data-fields.create",
    meta: { role: "Developer" },
    component: () => import("../views/pages/applications/data-fields/form"),
  },
  {
    path: "/applications/:applicationId/data-fields/:id/edit",
    name: "applications.data-fields.edit",
    meta: { role: "Developer" },
    component: () => import("../views/pages/applications/data-fields/form"),
  },
  {
    path: "/applications/:applicationId/logs",
    name: "applications.logs",
    meta: { permission: "read crash" },
    component: () => import("../views/pages/applications/logs/index"),
  },
  {
    path: "/applications/:applicationId/logs/:error",
    name: "applications.logs.show",
    meta: { permission: "read crash" },
    component: () => import("../views/pages/applications/logs/show"),
  },
  {
    path: "/financial",
    name: "financial",
    meta: { sidebar: true },
    label: "امور مالی",
    icon: "ri-coins-line",
    component: () => import("../App"),
    children: [
      {
        path: "transfer-requests",
        name: "transfer-requests",
        meta: { permission: "read transfer_request", sidebar: true },
        label: "دریافت درآمد",
        component: () => import("../views/pages/transfer-requests/index"),
      },
      {
        path: "wallet",
        name: "wallet",
        meta: { role: "Developer", sidebar: true },
        label: "کیف پول",
        component: () => import("../views/pages/wallet/index"),
      },
      {
        path: "wallet/charge",
        name: "wallet.charge",
        meta: { role: "Developer", sidebar: true },
        label: "شارژ کیف پول",
        component: () => import("../views/pages/wallet/charge"),
      },
      {
        path: "income",
        name: "income",
        meta: { role: "Developer", sidebar: true },
        label: "درآمد",
        component: () => import("../views/pages/income/index"),
      },
    ],
  },
  {
    path: "/tickets",
    name: "tickets",
    meta: { permission: "read ticket", sidebar: true },
    icon: "ri-customer-service-2-line",
    label: "پشتیبانی",
    component: () => import("../App"),
    children: [
      {
        path: "",
        name: "tickets",
        meta: { permission: "read ticket", sidebar: true },
        label: "لیست تیکت ها",
        component: () => import("../views/pages/tickets/index"),
      },
      {
        path: "create",
        name: "tickets.create",
        meta: { role: "Developer", sidebar: true },
        label: "ثبت تیکت جدید",
        component: () => import("../views/pages/tickets/form"),
      },
      {
        path: ":id",
        name: "tickets.show",
        meta: { permission: "read ticket" },
        component: () => import("../views/pages/tickets/form"),
      },
    ],
  },

  {
    path: "/error-404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("../views/pages/utility/error-404"),
  },
  {
    path: "/403",
    name: "Error-403",
    component: () => import("../views/pages/utility/error-403"),
  },
  {
    path: "/pages/error-500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("../views/pages/utility/error-500"),
  },

  {
    path: "/admins",
    name: "admins",
    meta: {
      role: "Admin",
      permission: "read admin",
    },
    component: () => import("../views/pages/admins/index"),
  },
  {
    path: "/admins/create",
    name: "admins.create",
    meta: { role: "Admin", permission: "create admin" },
    component: () => import("../views/pages/admins/form"),
  },
  {
    path: "/admins/:id",
    name: "admins.show",
    meta: { role: "Admin", permission: "read admin" },
    component: () => import("../views/pages/admins/show"),
  },
  {
    path: "/admins/:id/edit",
    name: "admins.edit",
    meta: { role: "Admin", permission: "update admin" },
    component: () => import("../views/pages/admins/form"),
  },
  {
    path: "/admins/:id/activities",
    name: "admins.activities",
    meta: { role: "Admin", permission: "show activity" },
    component: () => import("../views/pages/admins/activities"),
  },
  {
    path: "/developers",
    name: "developers",
    icon: "ri-dashboard-line",
    label: "توسعه دهندگان",
    meta: {
      sidebar: true,
      role: "Admin",
      permission: "read user",
    },
    component: () => import("../views/pages/developers/index"),
  },
  {
    path: "/developers/:id",
    name: "developers.show",
    meta: {
      role: "Admin",
      permission: "read user",
    },
    component: () => import("../views/pages/developers/show"),
  },
  {
    path: "/settings",
    name: "settings",
    meta: { sidebar: true, role: "Admin" },
    label: "تنظیمات",
    icon: "ri-settings-line",
    component: () => import("../App"),
    children: [
      {
        path: "mobile-brands",
        name: "mobile-brands",
        meta: { permission: "read mobile_brand", role: "Admin", sidebar: true },
        label: "برندهای موبایل",
        icon: "ri-apps-line",
        component: () => import("../App"),
        children: [
          {
            path: "",
            name: "mobile-brands",
            meta: {
              permission: "read mobile_brand",
              sidebar: true,
              role: "Admin",
            },
            label: "لیست برندهای موبایل",
            component: () => import("../views/pages/mobile-brands/index"),
          },
          {
            path: "create",
            name: "mobile-brands.create",
            meta: {
              role: "Admin",
              permission: "create mobile_brand",
              sidebar: true,
            },
            label: "ثبت برند جدید",
            component: () => import("../views/pages/mobile-brands/form"),
          },
          {
            path: ":id/edit",
            name: "mobile_brands.edit",
            meta: { role: "Admin", permission: "update mobile_brand" },
            component: () => import("../views/pages/mobile-brands/form"),
          },
        ],
      },
      {
        path: "net-providers",
        name: "net-providers",
        meta: { permission: "read net_provider", role: "Admin", sidebar: true },
        label: "ارائه دهندگان اینترنت",
        icon: "ri-apps-line",
        component: () => import("../App"),
        children: [
          {
            path: "",
            name: "net-providers",
            meta: {
              permission: "read net_provider",
              sidebar: true,
              role: "Admin",
            },
            label: "لیست ارائه دهندگان اینترنت",
            component: () => import("../views/pages/net-providers/index"),
          },
          {
            path: "create",
            name: "net-providers.create",
            meta: {
              role: "Admin",
              permission: "create net_provider",
              sidebar: true,
            },
            label: "ثبت ارائه دهنده جدید",
            component: () => import("../views/pages/net-providers/form"),
          },
          {
            path: ":id/edit",
            name: "net-providers.edit",
            meta: { role: "Admin", permission: "update net_provider" },
            component: () => import("../views/pages/net-providers/form"),
          },
        ],
      },
      {
        path: "operators",
        name: "operators",
        meta: { permission: "read operator", role: "Admin", sidebar: true },
        label: "اپراتورها",
        icon: "ri-apps-line",
        component: () => import("../App"),
        children: [
          {
            path: "",
            name: "operators",
            meta: {
              permission: "read operator",
              sidebar: true,
              role: "Admin",
            },
            label: "لیست اپراتورها",
            component: () => import("../views/pages/operators/index"),
          },
          {
            path: "create",
            name: "operators.create",
            meta: {
              role: "Admin",
              permission: "create operator",
              sidebar: true,
            },
            label: "ثبت اپراتور جدید",
            component: () => import("../views/pages/operators/form"),
          },
          {
            path: ":id/edit",
            name: "operators.edit",
            meta: { role: "Admin", permission: "update operator" },
            component: () => import("../views/pages/operators/form"),
          },
        ],
      },
      {
        path: "locations",
        name: "locations",
        meta: { permission: "read location", role: "Admin", sidebar: true },
        label: "مناطق جغرافیایی",
        icon: "ri-apps-line",
        component: () => import("../App"),
        children: [
          {
            path: "",
            name: "locations",
            meta: {
              permission: "read location",
              sidebar: true,
              role: "Admin",
            },
            label: "لیست مناطق جغرافیایی",
            component: () => import("../views/pages/locations/index"),
          },
          {
            path: "create",
            name: "locations.create",
            meta: {
              role: "Admin",
              permission: "create location",
              sidebar: true,
            },
            label: "ثبت منطقه جغرافیایی جدید",
            component: () => import("../views/pages/locations/form"),
          },
          {
            path: ":id/edit",
            name: "locations.edit",
            meta: { role: "Admin", permission: "update location" },
            component: () => import("../views/pages/locations/form"),
          },
        ],
      },
      {
        path: "android-api-levels",
        name: "android-api-levels",
        meta: { permission: "read setting", role: "Admin", sidebar: true },
        label: "ورژن های اندروید",
        icon: "ri-apps-line",
        component: () => import("../App"),
        children: [
          {
            path: "",
            name: "android-api-levels",
            meta: {
              permission: "read setting",
              sidebar: true,
              role: "Admin",
            },
            label: "لیست ورژن های اندروید",
            component: () => import("../views/pages/android-api-levels/index"),
          },
          {
            path: "create",
            name: "android-api-levels.create",
            meta: {
              role: "Admin",
              permission: "create setting",
              sidebar: true,
            },
            label: "ثبت ورژن اندروید جدید",
            component: () => import("../views/pages/android-api-levels/form"),
          },
          {
            path: ":id/edit",
            name: "android-api-levels.edit",
            meta: { role: "Admin", permission: "update setting" },
            component: () => import("../views/pages/android-api-levels/form"),
          },
        ],
      },
    ],
  },
];

export default routes;
